const $ = require('jquery')

const ajaxLoader = require('./ajaxLoader')
const { URL_API } = require('./api')

/**
 * Because for now YT videos are implemented by iframe in template - not via fully javascript,
 * we need to pause every video at every slick/modal actions.
 * Will be refactored and implemented in YT js module during frontend & YT component improvement.
 */
const pauseVideosInModal = function() {
  const $modalGalleryWrapper = $('.modal__gallery-slides')
  const $galleryVideoElements = $modalGalleryWrapper.find('.modal__gallery-slide').not('.slick-cloned')

  const videoList = $galleryVideoElements.map(function(i, item) {
    const $iframeElem = $(item).find('iframe')
    return $iframeElem.length ? $iframeElem : null
  })

  return videoList.map(function(i, item) {
    item[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*')
  })
}

// =========================================================================
// Module: Modals
// =========================================================================
const modals = {
  modalShow () {
    // -----------------------------------------------------------------------
    // Modal ???
    // -----------------------------------------------------------------------
    $(document).on('click', '.offer-hover', function(e) {
      e.preventDefault()
      const target = $($(this).attr('data-target'))

      if (target.is('.modal__overlay')) {
        target.fadeIn()
        $('body').addClass('noscroll')
      }
    })

    // -----------------------------------------------------------------------
    // Modal open
    // -----------------------------------------------------------------------
    $(document).on('click', '.modal-link', function(e) {
      e.preventDefault()
      e.stopPropagation()
      const target = $($(this).attr('data-target'))
      if (target.is('.modal__overlay')) {
        if (target.is('#modal-gallery')) {
          // -----------------------------------------------------------------
          // Modal open: gallery
          // -----------------------------------------------------------------
          const btnLoad = $(e.currentTarget)

          let urlJson = URL_API.loadGalleryList + btnLoad.attr('data-href')
          urlJson = `${urlJson}&startIndex=1`

          $('#modal-gallery .modal__gallery').empty()

          const config = {
            devTest: true,
            url: urlJson,
            method: 'GET',
            templateName: 'GallerySlider',
            //TemplateId: '#xht--gallery-list',
            elemCaller: btnLoad,
            type: 'gallery',
            placeholder: $('#modal-gallery .modal__gallery'),
            callback () {
              const parentSel = $('#modal-gallery')
              const callbackWait = setInterval(function() {
                if ($('.modal__gallery-slider').length > 0) {
                  modals.modalSlider(parentSel, btnLoad)
                  modals.modalGallery()
                  clearInterval(callbackWait)
                }
              }, 100)
            },
          }

          ajaxLoader.init(config)

          target.fadeIn()
          $('body').addClass('noscroll')

        } else if (target.is('#modal-dolphin')) {
          // -----------------------------------------------------------------
          // Modal open: gallery of dolphin club
          // -----------------------------------------------------------------
          const btnLoad = $(e.currentTarget)

          const elemDolphinClubGallery = $('.dolphin-club__gallery')
          const urlJson = `${URL_API.DolphinClubPhotos}?HotelGuid=${elemDolphinClubGallery.attr('data-hotelguid')}&clubguid=${elemDolphinClubGallery.attr('data-clubguid')}`

          $('#modal-dolphin .modal__gallery').empty()

          const config = {
            devTest: true,
            url: urlJson,
            method: 'GET',
            templateName: 'GalleryDolphin',
            //TemplateId: '#xht--gallery-list',
            elemCaller: btnLoad,
            type: 'gallery',
            placeholder: $('#modal-dolphin .modal__gallery'),
            callback () {
              const parentSel = $('#modal-dolphin')
              const callbackWait = setInterval(function() {
                if ($('.modal__gallery-slider').length > 0) {
                  modals.modalSlider(parentSel, btnLoad)
                  modals.modalGallery()
                  clearInterval(callbackWait)
                }
              }, 100)
            },
          }

          log.debug(config)

          ajaxLoader.init(config)

          target.fadeIn()
          $('body').addClass('noscroll')

          //$('#modal-dolphin').fadeIn();
          //$('body').addClass('noscroll');
        } else {
          target.fadeIn()
        }
      }
    })

    // -----------------------------------------------------------------------
    // Modal close
    // -----------------------------------------------------------------------
    $('.modal__close').on('click', function(e) {
      closeModal(e)
      $(document).unbind('keydown')
    })

    $(document).on('keydown', function(e) {
      const keycode = ((typeof e.keyCode != 'undefined' && e.keyCode) ? e.keyCode : e.which)
      if (keycode === 27) {
        closeModal(e)
      }
    })

    /**
     * Remove "fadeIn" class if exist
     * 
     * @param {Element} target 
     */
    function removeModalFadeInClass (target) {
      if (target.hasClass('fadeIn')) {
        return target.removeClass('fadeIn')
      }
      
      return false
    }

    function closeModal (e) {
      e.preventDefault()
      const target = $('.modal__close').closest('.modal__overlay')
      target.fadeOut().promise().done(() => removeModalFadeInClass(target))

      $('body').removeClass('noscroll')
      pauseVideosInModal()
    }
  },

  modalGallery () {
    $('.modal__gallery-see-all').click(function(e) {
      e.preventDefault()
      const target = $(this).closest('.modal__overlay')

      target.find('.modal__gallery-slider').hide()
      target.find('.modal__gallery-grid').fadeIn()
      pauseVideosInModal()
    })

    $('.modal__gallery-grid-item').click(function(e) {
      e.preventDefault()
      const target = $(this).closest('.modal__overlay')

      target.find('.modal__gallery-grid').hide()
      target.find('.modal__gallery-slider').fadeIn()

      modals.modalMoveSlide(this, target)
    })

    $('.modal__gallery-thumb--desktop').click(function(e) {
      e.preventDefault()
      const target = $(this).closest('.modal__overlay')

      modals.modalMoveSlide(this, target)
    })

  },

  modalSlider (parentSel, btnLoad) {
    const $modalThumbsDesktop = $('.modal__gallery-thumbs--desktop')
    const setInitialSlideIndex = function() {
      if (btnLoad.is('[href]')) {
        const slideIndex = btnLoad.attr('href').split('#').join('')
        return parseInt(slideIndex)
      } else {
        return 0
      }
    }

    parentSel.find('.modal__gallery-slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev"><span class="custom-icon--arr-left" aria-hidden="true"></span><span class="sr-only>Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next"><span class="custom-icon--arr-right" aria-hidden="true"></span><span class="sr-only>Next</span></button>',
      asNavFor: '.modal__gallery-thumbs--desktop',
      variableWidth: false,
      initialSlide: setInitialSlideIndex(),
      responsive: [ {
        breakpoint: 767,
        settings: {
          arrows: false,
          variableWidth: true,
        },
      } ],
    })
    parentSel.find('.modal__gallery-thumbs--desktop').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.modal__gallery-slides',
      centerMode: false,
      focusOnSelect: true,
      arrows: false,
      initialSlide: setInitialSlideIndex(),
    })

    $('.modal__gallery-slides').find('.slick-arrow').on('click', pauseVideosInModal)

    // Need to reset slick css because of transform misscalculations
    if ($modalThumbsDesktop.find('.slick-slide').length <= 3) {
      $modalThumbsDesktop.addClass('resetSlickTransforms')
    }

    $(document).on('keydown', function(e) {
      if (e.keyCode == 37) {
        parentSel.find('.modal__gallery-slides').slick('slickPrev')
        pauseVideosInModal()
      } else if (e.keyCode == 39) {
        parentSel.find('.modal__gallery-slides').slick('slickNext')
        pauseVideosInModal()
      }
    })
  },

  modalMoveSlide (clicked, mainParent) {
    const target = mainParent.find('.modal__gallery-slides')
    const slideNr = clicked.hash.slice(1)

    target.slick('slickGoTo', slideNr)
    pauseVideosInModal()
  },

  createModalsPlaceholder () {
    const body = document.querySelector('body')
    const main = document.createElement('div')
    main.classList.add('page-modal')

    main.style.position = 'relative'
    main.style.zIndex = '10000'
    
    body.insertAdjacentElement('beforeend', main)
  },
}

module.exports = modals



// WEBPACK FOOTER //
// ./src/modules/modals.js